/*
 * purchase-block-qty.js
 * -------------------------------------------------------------------
 * 商品詳細ページ「購入ブロック」の数量セレクタ用ハンドラ。
 * snippets/purchase-block-normal.liquid / purchase-block-preorder.liquid の
 *
 *   <div class="qty-box">
 *     <button data-qty-decrease>−</button>
 *     <input type="number" name="quantity" min=".." max="..">
 *     <button data-qty-increase>＋</button>
 *   </div>
 *
 * を制御する。
 *
 * 仕様:
 *   - 同一 .qty-box 内の number input を対象にする
 *   - min / max / step を尊重（既定 step=1）
 *   - 値変更後に input イベント / change イベントを発火し、
 *     上位の product-form 等に変更を伝搬させる
 *   - disabled な qty-box は無視（在庫切れ／販売開始前用）
 *   - イベント委譲方式なので、テーマエディタで再描画されても動く
 */

(function () {
  'use strict';

  /**
   * クリックされたボタンに対応する <input> を取得
   */
  function findInput(button) {
    var box = button.closest('.qty-box');
    if (!box) return null;
    return box.querySelector('input[type="number"]');
  }

  /**
   * 値を整数として読む（不正値は min にフォールバック）
   */
  function readValue(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v)) {
      var minV = parseInt(input.min, 10);
      return isNaN(minV) ? 1 : minV;
    }
    return v;
  }

  /**
   * min / max にクランプ
   */
  function clamp(value, input) {
    var minV = parseInt(input.min, 10);
    var maxV = parseInt(input.max, 10);
    if (!isNaN(minV) && value < minV) value = minV;
    if (!isNaN(maxV) && value > maxV) value = maxV;
    return value;
  }

  /**
   * 値を更新して change/input イベントを発火
   */
  function setValue(input, next) {
    var prev = input.value;
    var clamped = String(clamp(next, input));
    if (prev === clamped) return;
    input.value = clamped;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * クリックハンドラ（イベント委譲）
   */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-decrease], [data-qty-increase]');
    if (!btn) return;

    // 在庫切れ等で disabled な qty-box は無視
    var box = btn.closest('.qty-box');
    if (!box || box.classList.contains('disabled')) return;
    if (btn.disabled) return;

    var input = findInput(btn);
    if (!input || input.disabled) return;

    event.preventDefault();

    var step = parseInt(input.step, 10);
    if (isNaN(step) || step < 1) step = 1;

    var current = readValue(input);
    var delta = btn.hasAttribute('data-qty-decrease') ? -step : step;
    setValue(input, current + delta);
  });

  /**
   * 直接入力された値も clamp する（手入力で max を超えた場合の保険）
   */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== 'number') return;
    if (!input.closest('.qty-box')) return;

    var raw = readValue(input);
    var clamped = clamp(raw, input);
    if (raw !== clamped) {
      input.value = String(clamped);
    }
  });
})();
